import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { AppImage } from '../AppImage';
import { site, socialLinks } from '../../data/site';
import { contactSidebarImage } from '../../data/contactImages';
export function ContactAside() {
  return <div className="lg:sticky lg:top-[112px]" data-id="element-259" data-mp="3l08dcemihuic">
      <AppImage src={contactSidebarImage.image} alt={contactSidebarImage.alt} ratio="4:3" className="mb-6" data-id="element-260" data-mp="3psrshg0ukxp9" />
      <div className="rounded-card border-2 border-ink bg-canvas p-6" data-id="element-261" data-mp="3ur31jojbj46f">
        <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-262" data-mp="3jywv0anbu16">Response time</p>
        <p className="mt-4 text-[28px] leading-[1.1] tracking-[-0.03em] text-ink" data-id="element-263" data-mp="8juw6m8eexae">
          Within 1 business day
        </p>
        <p className="mt-4 max-w-[34ch] text-small leading-6 text-muted" data-id="element-264" data-mp="cl6iahs2d0du">
          Every enquiry is answered personally, not by an assistant and not by an autoresponder.
          Usually the same day.
        </p>
        <p className="mt-6 flex items-center gap-2.5 border-t border-hairline pt-5 text-small text-muted" data-id="element-265" data-mp="2ef5quvdsx3mu">
          <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-266" data-mp="3goxrnhyfhw4u" />
          Currently taking on new projects.
        </p>
      </div>

      <div className="mt-6 rounded-card border border-hairline bg-canvas p-6" data-id="element-267" data-mp="36ycttwqkwvmz">
        <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-268" data-mp="31yqgzoenxhep">Prefer to talk?</p>
        <a href={`mailto:${site.email}`} className="mt-4 inline-flex items-center gap-2 text-[20px] tracking-[-0.02em] text-ink transition-colors duration-150 ease-out hover:text-accent" data-id="element-269" data-mp="3gb8qlw3poev">
          {site.email}
          <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-270" data-mp="3pm81qzziff86" />
        </a>
        <a href={site.phoneHref} className="mt-3 block text-[20px] tracking-[-0.02em] text-ink transition-colors duration-150 ease-out hover:text-accent" data-id="element-271" data-mp="3kpho0jb6gvpx">
          {site.phone}
        </a>
        <p className="mt-4 text-[13px] leading-6 text-[#6E6E6E]" data-id="element-272" data-mp="298rotk56945t">
          Calls and WhatsApp, 10:00–19:00 IST, Monday to Friday.
        </p>
      </div>

      <div className="mt-6 grid gap-6 rounded-card border border-hairline bg-canvas p-6 sm:grid-cols-2 lg:grid-cols-1" data-id="element-273" data-mp="15bpe6agni9zx">
        <div data-id="element-274" data-mp="rcpmetxudezj">
          <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-275" data-mp="rav29hue9qwi">Where we are</p>
          <p className="mt-4 text-small leading-6 text-ink" data-id="element-276" data-mp="wa7vckbuzu7j">India</p>
          <p className="mt-2 max-w-[30ch] text-small leading-6 text-muted" data-id="element-277" data-mp="hm4o77m2ych5">
            Working remotely with clients across India. 10:00–19:00 IST, Monday to Friday.
          </p>
        </div>

        <div className="lg:mt-2 lg:border-t lg:border-hairline lg:pt-6" data-id="element-278" data-mp="8lf06q329qdz">
          <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-279" data-mp="8jby37omw6sw">Elsewhere</p>
          <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2" data-id="element-280" data-mp="dkrjx1ymyhcc">
            {socialLinks.map(link => <li key={link.label} data-id="element-281" data-mp="3utes6dploko5">
                <a href={link.to} target="_blank" rel="noreferrer" className="text-small text-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-282" data-mp="3m2bs0wjkb9a">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
}